import { DEBUG, PATH } from '../constants';


const base = PATH;
const debug = DEBUG;

// export async function getAllUsers() {
//     try {
//         //Ajouter le token dans l'en-tête HTTP
//       const response = await fetch(base + 'users');
//       return await response.json();
//     } catch (error) {
//       if(debug) console.error('Erreur getAllUsers', error);
//       throw error;
//     }
// }

export async function getUser(id) {
    try {
        const response = await fetch(base + 'users/' + id);
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur getUser', error);
        throw error;
    }
}

export async function createUser(email, pseudo, mdp, mdp2, cp, country) {
    try {
        const response = await fetch(base + 'users/insert', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, pseudo, mdp1: mdp, mdp2: mdp2, cp, country }),
        });
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur createUser', error);
        throw error;
    }
}

export async function connectUser(pseudoOrEmail, mdp) {
    try {
        const response = await fetch(base + 'users/connect', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ info: pseudoOrEmail, mdp }),
        });
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur connectUser', error);
        throw error;
    }
}

export async function isPseudoExists(pseudo) {
    try {
        const response = await fetch(base + 'users/checkpseudo', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ pseudo }),
        });
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur isPseudoExists', error);
        throw error;
    }
}

export async function isEmailExists(email) {
    try {
        const response = await fetch(base + 'users/checkmail', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email }),
        });
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur isEmailExists', error);
        throw error;
    }
}

export async function updatePassword(mdp, token) {
    try {
        const response = await fetch(base + 'users/update', {
            method: 'POST',
            credentials: "include",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body: JSON.stringify({ mdp }),
        });
        return await response.json();
    } catch (error) {
        if(debug) console.error('Erreur updatePassword', error);
        throw error;
    }
}

export async function getAllUsers({ page = 1, limit = 20, q = '' }) {
    const authToken = localStorage.getItem("authToken");
    try {
        const response = await fetch(`${base}users`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${authToken}`, // Authentification
        },
        body: JSON.stringify({ q, page, limit }), // Recherche + pagination
        });

        if (!response.ok) {
            throw new Error(`Erreur HTTP ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        if (debug) console.error('Erreur getAllUsers', error);
        throw error;
    }
}


export async function updateUserRole(id, role) {
    const token = localStorage.getItem("authToken");
    try {
        const response = await fetch(`${PATH}users/updaterole`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ id, role }),
        });

        if (!response.ok) {
            const error = await response.json();
            throw new Error(error?.message || 'Erreur lors de la mise à jour du rôle');
        }

        return await response.json();
    } catch (error) {
        if (DEBUG) console.error('Erreur updateUserRole', error);
        throw error;
    }
}

export async function getTotalPlayers() {
    const authToken = localStorage.getItem("authToken");
    try {
        const response = await fetch(`${PATH}users/total-players`, {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${authToken}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Erreur HTTP ${response.status}`);
        }

        return await response.json(); // { total: 123 }
    } catch (error) {
        if (DEBUG) console.error('Erreur getTotalPlayers', error);
        throw error;
    }
}
